//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        background: {
            type: String,
            default: '/images/game/offboarding/robi_charging_bg.png'
        },
        buttonText: {
            type: String,
            default: function () {
                return this.$lang.get('partials.offboarding.continue');
            }
        }
    },

    computed: {
        nextRoute () {
            let currentRouteIndex = this.$router.options.routes.findIndex(route => route.name === this.$route.name);
            return this.$router.options.routes[currentRouteIndex + 1];
        },
        isNextRouteUnlocked () {
            return this.$store.getters.isRouteUnlocked(this.nextRoute);
        },
        nextRouteTimeDifference () {
            return this.$store.getters.routeTimeDifference(this.nextRoute);
        }
    }
};
